import {
  Space,
  Table,
  Tag,
  Popconfirm,
  Pagination,
  Tooltip,
  Button,
  Switch,
} from "antd";
import { ColumnsType } from "antd/es/table";
import { BiEdit } from "react-icons/bi";
import { LuUndo2 } from "react-icons/lu";
import { IoTrashOutline } from "react-icons/io5";
import { IoShareSocialOutline } from "react-icons/io5";
import { IoEyeOutline } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
import moment from "moment";
import { SiMicrosoftexcel } from "react-icons/si";
import { useState } from "react";
import * as XLSX from "xlsx";
import { API } from "../../config/API";
import { GET, POST_NO_LOGOUT } from "../../utils/apirequest";
import { useSelector } from "react-redux";

function DataTable(props: any) {
  const [isLoading, setIsloading] = useState(false);
  const User = useSelector((state: any) => state?.User);
  const isAdmin = User?.user?.role?.id === 4;
  interface DataType {
    key: string;
    id: number;
    news: string;
    newshead: string;
    address: string;
    imageurl: string[];
  }
  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 50,
      render: (text, record, index) => {
        return <div className="">{(props.page - 1) * props.pagesize + index + 1}.</div>;
      },
    },
    {
      title: "Preview",
      key: "image",
      dataIndex: "image",
      width: 20,
      render: (text, record: any) => {
        return (
          <div>
            {record?.image ? (
              <img
                key={record?.image}
                src={record?.image}
                alt="Table Image"
                style={{ height: 40, borderRadius: 6 }}
              />
            ) : (
              <div className="homescreen-table-NoImg">No media</div>
            )}
          </div>
        );
      },
    },
    {
      title: "title",
      dataIndex: "title",
      key: "title",
      width: 350,
      render: (text, record: any) => {
        return (
          <div
            style={{ fontSize: "10px" }}
            onClick={() => props.onEdit(record)}
          >
            {record?.title}
          </div>
        );
      },
    },
    {
      title: "head",
      dataIndex: "head",
      key: "head",
      width: 350,
      render: (text, record: any) => {
        return (
          <div
            style={{ fontSize: "10px" }}
            onClick={() => props.onEdit(record)}
          >
            {record?.title}
          </div>
        );
      },
    },
    {
      title: "WhatsApp",
      key: "whatsappGroupLink",
      dataIndex: "whatsappGroupLink",
      width: 80,
      render: (text, record: any) => {
        return record?.whatsappGroupLink ? (
          <Tooltip title="Open WhatsApp Group" color={"black"}>
            <a
              href={record?.whatsappGroupLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp size={22} color="#25D366" cursor={"pointer"} />
            </a>
          </Tooltip>
        ) : (
          <FaWhatsapp size={22} color="#d9d9d9" />
        );
      },
    },
    {
      title: "Active",
      dataIndex: "is_active",
      key: "is_active",
      render: (text, record: any) => {
        return (
          <Space size="middle">
            <Switch
              onClick={() => props.toggleStatus(record)}
              checked={record?.publishedAt}
            />
          </Space>
        );
      },
    },
    {
      title: "created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record: any) => {
        return <div>{moment(text).format("DD-MM-YYYY")}</div>;
      },
    },
    {
      title: "Status",
      key: "publishedAt",
      render: (text, record: any) => {
        return (
          <Space size="middle">
            <Tag
              color={
                record?.is_deleted === true
                  ? "red"
                  : record?.publishedAt
                    ? "green"
                    : "blue"
              }
              style={{ fontSize: "10px" }}
            >
              {record?.is_deleted === true
                ? "Trash"
                : record?.publishedAt
                  ? "Published"
                  : "Draft"}
            </Tag>
          </Space>
        );
      },
    },
    {
      title: "Task",
      key: "action",
      render: (_, record: any) => {
        return (
          <div className="table-action">
            <div>
              <Tooltip title="View Form" color={"black"}>
                <Button
                  onClick={() => props.onView(record)}
                  type="text"
                  size="small"
                >
                  <IoEyeOutline size={20} color="#0055a6" cursor={"pointer"} />
                </Button>
              </Tooltip>
            </div>
            {isAdmin ? (
              <div>
                <Button
                  onClick={() => generateExcel(record.id)}
                  loading={isLoading}
                  type="text"
                  size="small"
                >
                  <SiMicrosoftexcel size={18} cursor={"pointer"} />
                </Button>
              </div>
            ) : null
            }
            <div>
              <Button
                onClick={() => props.shareModal(record)}
                type="text"
                size="small"
              >
                <IoShareSocialOutline
                  size={20}
                  color="#000"
                  cursor={"pointer"}
                />
              </Button>
            </div>
            <div>
              <Button
                onClick={() => props.onEdit(record)}
                type="text"
                size="small"
              >
                <BiEdit size={20} color="#f5a442" cursor={"pointer"} />
              </Button>
            </div>
            <div>
              <Tooltip
                title={`${record?.is_deleted === true ? "Recover" : "Move"
                  } From Trash`}
                color={"black"}
              >
                {record?.is_deleted === true ? (
                  <LuUndo2
                    color="blue"
                    size={20}
                    cursor={"pointer"}
                    onClick={() => props.unTrash(record)}
                  />
                ) : (
                  <IoTrashOutline
                    color="red"
                    size={20}
                    cursor={"pointer"}
                    onClick={() => props.onTrash(record)}
                  />
                )}
              </Tooltip>
            </div>

            {record.is_deleted === true ? (
              <div>
                <Popconfirm
                  title="Delete the task"
                  description="Are you sure to delete this task?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => props?.onDelete(record)}
                >
                  <Button size="small" danger style={{ fontSize: 12 }}>
                    Remove
                  </Button>
                </Popconfirm>
              </div>
            ) : null}
          </div>
        );
      },
    },
  ];

  const generateExcel = async (id: any) => {
    try {
      setIsloading(true);

      const [formDef, data]: any = await Promise.all([
        GET(API.DYNAMIC_FORM_DETAILS + id, null, null),
        POST_NO_LOGOUT(API.DYNAMIC_FORM_RESPONSES, { formId: id }),
      ]);

      const formFields: any[] =
        JSON.parse(formDef?.data?.attributes?.fields)?.fields || [];
      const headers = formFields.map((f: any) => f.label);
      const fieldNames = formFields.map((f: any) => f.name);

      const dataArray = data
        .filter((ite: any) => ite.data && ite.data !== "[object Object]")
        .map((ite: any) => {
          const item = JSON.parse(ite.data);
          return fieldNames.map((name: any) => item[name] ?? "");
        });

      dataArray.unshift(headers);

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(dataArray);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "report.xlsx");
      setIsloading(false);
    } catch (err) {
      console.log(err);
      setIsloading(false);
    }
  };

  return (
    <>
      <div style={{ marginTop: "10px" }}>
        <Table
          columns={columns}
          dataSource={props.data}
          loading={props.loading}
          className="commen-table-custom-scrollbar"
          pagination={false}
          size="small"
        />
        <br />
        <div style={{ float: "right" }}>
          <Pagination
            responsive
            current={props?.page}
            total={props?.meta}
            pageSize={props?.pagesize}
            pageSizeOptions={["10", "20", "50", "100"]}
            showSizeChanger
            onChange={(p, t) => {
              props.onPageChange(p, t);
            }}
          />
        </div>
      </div>
    </>
  );
}

export default DataTable;
